import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material'
import CenteredContainer from '../components/ui/CenteredContainer'
import { useAuth } from '../hooks/context/UserAuthContext'
import { Navigate, Link as RouterLink } from 'react-router-dom'
import ForgotPasswordForm from '../components/forms/ForgotPasswordForm'
import { useForgotPassword } from '../hooks/api/auth'

const ForgotPassword = () => {
  const { user } = useAuth()

  if (user) {
    return <Navigate to='/' />
  }

  return (
    <CenteredContainer maxWidth='sm' sx={{ py: 2 }}>
      <Box mb={2}>
        <Typography variant='h5'>Forgot Password</Typography>
      </Box>
      <ForgotPasswordForm />
    </CenteredContainer>
  )
}

export default ForgotPassword
